import { call, put, takeLatest } from "redux-saga/effects";
import { fetchPapers } from "../../../services/paper";
import { getPapersStart, getPapersSuccess, getPapersFailure } from "../reducer";

export function* getPaper({ payload }) {
  const response = yield call(fetchPapers, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(getPapersSuccess(raw));
  } else {
    yield put(getPapersFailure(message || raw?.error));
  }
}

export default function* onGetPaper() {
  yield takeLatest(getPapersStart.type, getPaper);
}
